import * as lodash from 'lodash';
import { useContext } from 'react';
import { errorType, REVERT_ZK_CONFIG_ERROR_MESSAGE, revertSuccessMessage, revertWarningMessage, successType } from 'constant';
import { EMPTY_OBJECT, AppContext, EMPTY_STRING } from 'commons-ui';
import { Action, ACTION_ID, ActionHandlerParams } from '../types';
import useService from '../utils/useService';

export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { rowData = EMPTY_OBJECT, setForceUpdateRows, setConfirmationDialog } = params;
	const { showAlert } = useContext(AppContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const { requestRevertZkChange } = useService();
	switch (action.id) {
		case ACTION_ID.REVERT: {
			const revertZkConfig = async () => {
				const { data } = await requestRevertZkChange(appName, rowData);
				if (data.success) showAlert(revertSuccessMessage, { type: successType });
				else
					showAlert(data.externalMessage || REVERT_ZK_CONFIG_ERROR_MESSAGE, {
						type: errorType
					});
				setForceUpdateRows(true);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: `Do you want to revert "${rowData.key}" config?`,
					message: !lodash.isNil(rowData.oldValue) ? EMPTY_STRING : revertWarningMessage,
					handleAlertConfirmation: revertZkConfig
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
